/** Resting presentation only. No Number/Intl rounding, currency symbol, locale
 * inference or parsing of currency prose. Editing and persistence use raw text. */
export function formatMoneyDisplay(raw: string): string {
  const parts = /^(-?)(0|[1-9]\d*)(?:\.(\d+))?(?:e([+-]?\d+))?$/i.exec(raw);
  if (!parts || !Number.isFinite(Number(raw))) return raw;
  const [, sign, whole, fraction = '', exponent = '0'] = parts;
  const shift = Number(exponent);
  // A pathological zero exponent can be numerically finite while requesting
  // millions of display characters. Never expand unbounded document text.
  if (!Number.isSafeInteger(shift) || Math.abs(shift) > 1000 || raw.length > 4000) return raw;
  const digits = whole + fraction;
  const point = whole.length + shift;
  const integer = (point <= 0 ? '0' : digits.slice(0, point).padEnd(point, '0')).replace(
    /^0+(?=\d)/,
    '',
  );
  const decimals = point <= 0 ? '0'.repeat(-point) + digits : digits.slice(point);
  return `${sign}${integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${decimals.padEnd(2, '0')}`;
}
